export const userViewsTrustPilot = heading => ({
  type: '[View] Trustpilot Review',
  data: {
    ...(heading ? { component_heading: heading } : {}),
  },
});
